
// ZDE VLOŽTE ÚDAJE Z FIREBASE CONSOLE
// Najdete je v Project Settings -> General -> Your apps -> Config

export const firebaseConfigSettings = {
  apiKey: "AIzaSyA6syosFB8SFpTI3FjHx0hSBd1M0MzPV2c",
  authDomain: "samolepky-2.firebaseapp.com",
  projectId: "samolepky-2",
  storageBucket: "samolepky-2.firebasestorage.app",
  messagingSenderId: "630432367846",
  appId: "1:630432367846:web:edd08d0d3f0a0274516727",
  measurementId: "G-VL5KZEF3J2"
};

// reCAPTCHA v3 site key pro Firebase App Check.
// Najdete/vytvoříte v Firebase Console -> App Check -> Apps -> (web app) -> reCAPTCHA v3,
// nebo přímo v Google Cloud reCAPTCHA konzoli. Je to veřejný klíč, bezpečný pro frontend.
export const RECAPTCHA_V3_SITE_KEY = "6Lf1wpktAAAAAD45m_WIozaG0aloo4qn-z1Z4O9N";
